module.exports = __webpack_public_path__ + "img/bgr-easter.ec91f6d9.svg";